<template>
  <div>
    <div class="row">
      <div class="col">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Requested Date</th> 
                <th class="text-left">User</th>
                <th class="text-left">Publication</th>
                 <th class="text-left">Organization</th>              
                <th class="text-left">Start Date</th>
                <th class="text-left">End Date</th>
                <th class="text-left">Returned Date</th>
                <!-- <th style="width: 100px"></th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in list" :key="item.id">
                <td>{{ item.RequestedDate | formatDate}}</td>
                <td>{{ item.user == null ? "" : item.user.firstName }} {{ item.user == null ? "" : item.user.lastName  }}</td>
                <td>  {{ publicationType=1 ? item.publication == null ? "" : item.publication.Title  : "" }} 
                      {{ publicationType=2 ? item.journal == null ? ""  : item.journal.Title : "" }}
                </td>
                <td>{{ item.organization == null ? "" : item.organization.Name }}</td>
                <td>{{ item.StartDate | formatDate }}</td>
                <td>{{ item.EndDate | formatDate }}</td>
                <td>{{ item.returnedDate | formatDate  }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>
    <div class="row">
      <div class="pr-8 ml-auto">
        <a @click="downloadCompleted"
          ><v-icon large color="blue" class="px-1"> mdi-cloud-download </v-icon
          >Download</a
        >
      </div>
    </div>
    <div class="row">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage"/>
        </div>
      </div>
      <LendingStatus ref="lendingStatus"/>
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
  </div>
</template>
<script>
import Notification from "@/components/Notification";
import Pagination from "@/components/Pagination";
import LendingStatus from "@/components/LendingStatus";
import * as api from "@/api";

export default {
  name: 'LendingCompleted',
  components: {
    Notification,
    Pagination,
    LendingStatus
  },
  created() {
    this.getLending();
  },
  methods: {
    getLending() {
      let that = this;
      that.overlay = true
       this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("lending/completed", this.paging)
          .then((response) => {
            resolve(response);
            this.paging.count = response.data.count;
            this.list = response.data.data;
            console.log(this.list);
            that.overlay = false
          })
          .catch((error) => {
            that.overlay = false
            reject(error);
          });
      });
    },
    onSearch() {
      console.log("onSearch" + this.Search);
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getLending();
    },
    onNextPage(page) {
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getLending();
    },
       onStatus(item){
       this.$refs.lendingStatus.open("Lending Status", item.lendingStatus);
    },
    downloadCompleted() {
      api.downloadFile("lending/download/completed", "completed.csv")
    }
  },

  computed: {},
  watch: {},

  data() {
    return {
      list: [],
      Search: "",
      paging: { count: 10, page: 1, size: 10, keyword: "" },
      overlay: false
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/LendingCompleted.vue